import React from "react";
import { Box, Container, Typography, Grid, Card, CardContent, useTheme } from "@mui/material";

// Data
const services = [
  {
    title: "Sales & Installation",
    description:
      "Offering expert consultation on HVAC products, ensuring the right system for your needs, followed by professional installation for optimal performance.",
  },
  {
    title: "Home & Office Air Conditioning",
    description:
      "Providing efficient, reliable air conditioning solutions tailored for homes and offices, enhancing comfort and energy savings.",
  },
  {
    title: "Industrial Air Conditioning",
    description:
      "Robust, large-scale cooling systems designed to meet the demands of industrial environments, ensuring optimal performance and productivity.",
  },
  {
    title: "Preventive Maintenance",
    description:
      "Regular upkeep to extend HVAC lifespan, improve performance, and prevent costly repairs.",
  },
  {
    title: "Troubleshooting & Repairs",
    description:
      "A wide network of experts to diagnose and solve HVAC problems to minimize downtime.",
  },
  {
    title: "Air Quality Control",
    description:
      "We improve indoor air quality with solutions like dehumidification, filtration, and cleanliness management.",
  },
  {
    title: "Cold Storage & Heat Exchangers",
    description:
      "Supply, install, and maintain cold storage systems and heat exchangers to meet diverse cooling needs.",
  },
  {
    title: "HVAC Systems Design Assist",
    description:
      "Collaborative design support to create efficient, innovative, and customized HVAC solutions for your needs.",
  },
  {
    title: "Customer Education",
    description:
      "Empowering clients with knowledge to maximize their HVAC systems efficiency and longevity.",
  },
  {
    title: "Online Reporting System",
    description:
      "We developed our proprietary MasterSystem, an IT-driven platform that provides data-driven reports and diagnostics.",
  },
];

// Card component
const ServiceCard = ({ title, description }) => {
  const theme = useTheme();

  return (
    <Card
      elevation={3}
      sx={{
        height: "100%",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "scale(1.03)",
          boxShadow: theme.shadows[6],
        },
        borderRadius: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <CardContent>
        <Typography variant="h6" color="#344767" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
      </CardContent>
    </Card>
  );
};

// Main Section
const WhatWeDo = () => {
  return (
    <Box sx={{ py: 10, backgroundColor: "#f9fafb" }}>
      <Container maxWidth="lg">
        <Typography variant="h3" align="center" color="#344767" fontWeight="bold" gutterBottom>
          WHAT WE DO
        </Typography>
        <Typography variant="body2" color="text" mb={2} align="center">
          Here are some of the benefits of this application
        </Typography>
        <Grid container spacing={4} mt={4}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <ServiceCard title={service.title} description={service.description} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhatWeDo;
